/**
 * Owner: Masa Bayu
 * File: DiscoveryBookGrid.tsx
 * Date:Time: 2026-09-18 06:32
 * Description: PW-D shared discovery grid — QxBookCard · catalog cards only.
 */

import type { QxreadBookCard } from '@qx/qxread-core';
import { findCatalogOffer } from '../commerce/catalog-offers';
import { formatMarketplacePriceOrUnknown } from '../home/marketplace/marketplace-locale';
import { QxBookCard } from './QxBookCard';

export interface DiscoveryBookGridProps {
  readonly cards: readonly QxreadBookCard[];
  readonly onNavigate: (path: string) => void;
  readonly listLabel: string;
  readonly idPrefix?: string;
}

/** Shared cover grid for Search · Discover — one card model · D/T/M via foundation. */
export function DiscoveryBookGrid({
  cards,
  onNavigate,
  listLabel,
  idPrefix = 'discovery',
}: DiscoveryBookGridProps) {
  return (
    <ul className="book-grid" aria-label={listLabel} data-pw-d-grid="catalog">
      {cards.map((card) => {
        const offer = findCatalogOffer(card.publicationId);
        const priceLabel =
          offer !== null
            ? formatMarketplacePriceOrUnknown(
                offer.sellerPriceMinorUnits,
                offer.currency,
                'Price unavailable',
              )
            : undefined;
        return (
          <li key={card.publicationId}>
            <QxBookCard
              card={card}
              onNavigate={onNavigate}
              idPrefix={idPrefix}
              variant="cover"
              {...(priceLabel !== undefined ? { priceLabel } : {})}
            />
          </li>
        );
      })}
    </ul>
  );
}
